// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimsList-cls1_tyt","cls2":"ClaimsList-cls2_teB ClaimsList-cls1_tyt"};